import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, type JSX, type ReactNode } from "react";

import { drawerSlide, scrimFade } from "../lib/motion";
import { IconButton } from "./primitives";
import { IconClose } from "./icons";

/** A right-side drawer with scrim, focus handling, and Escape-to-close. Reused by Settings + Debug. */
export function Drawer({ open, title, onClose, children }: { open: boolean; title: string; onClose: () => void; children: ReactNode }): JSX.Element {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) panelRef.current?.focus();
  }, [open]);

  return (
    <AnimatePresence>
      {open ? (
        <motion.div className="voss-scrim" variants={scrimFade} initial="hidden" animate="visible" exit="exit" onClick={onClose}>
          <motion.div
            className="voss-drawer"
            variants={drawerSlide}
            initial="hidden"
            animate="visible"
            exit="exit"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            tabIndex={-1}
            ref={panelRef}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="voss-drawer__head">
              <div className="voss-drawer__title">{title}</div>
              <IconButton label="Close" onClick={onClose}>
                <IconClose />
              </IconButton>
            </div>
            <div className="voss-drawer__body">{children}</div>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
